/* eslint-disable no-console */
import firebase from 'firebase/app'
import 'firebase/firebase-firestore'
import * as constants from '../../../constants.json'

export default {
  /**
   * Properties from the app state.
   * @property {array} state.orders        - The error message.
   */
  state: {
    orders: null,
    orderDialog: false
  },

  mutations: {

    /**
     * Mutation method to load the orders to the state
     * @param {*} state   - The state property.
     * @param {*} orders  - The orders object
     */
    mutationLoadOrders (state, orders) {
      state.orders = orders
    },

    /**
     * Mutation method that delete a given order from state
     * @param {*} state   - The state property.
     * @param {*} orderId - The order id
     */
    mutationDeleteOrder (state, orderId) {
      state.orders.splice(state.orders.findIndex(order => order.orderId === orderId), 1)
      console.log('state.orders: ', state.orders)
    },

    /**
     * Mutation method that update a given order from state
     * @param {*} state   - The state property
     * @param {*} payload - Properties: orderId, status
     */
    mutationUpdateOrder (state, payload) {
      const index = state.orders.findIndex(order => order.orderId === payload.orderId)
      state.orders[index].status = payload.status
    },

    /**
     * Mutation method to open or close the order dialog
     * @param {*} state   - The state property.
     * @param {*} open    - Boolean
     */
    mutationOrderDialog (state, open) {
      state.orderDialog = open
    }
  },

  actions: {
    /**
     * Get the orders from db and load them to the state.
     * @param {*} param0   - The commit object
     * @param {*} payload  - Properties: companyId
     */
    async actionLoadOrders ({ commit }, companyId) {
      try {
        console.log('Loading orders')
        commit('mutationSetLoading', true)

        // Get orders doc with status equal to awaiting
        const ordersDocs1 = await firebase
          .firestore()
          .collectionGroup('orders')
          .where('companyId', '==', companyId)
          .where('botId', '==', constants.BOT_ID)
          .where('status', '==', 'awaiting')
          .get()

        const orders = []
        ordersDocs1.forEach(orderDoc => {
          orders.push({ ...orderDoc.data(), orderId: parseInt(orderDoc.id) })
        })

        // Get orders doc with status equal to processed
        const ordersDocs2 = await firebase
          .firestore()
          .collectionGroup('orders')
          .where('companyId', '==', companyId)
          .where('botId', '==', constants.BOT_ID)
          .where('status', '==', 'processed')
          .get()

        // Sorting orders alphabetically
        ordersDocs2.forEach(orderDoc => {
          orders.push({ ...orderDoc.data(), orderId: parseInt(orderDoc.id) })
        })

        orders.sort((a, b) => {
          return a.orderId - b.orderId
        })
        console.log('orders: ', orders)

        commit('mutationLoadOrders', orders)
        commit('mutationSetLoading', false)
      } catch (error) {
        commit('mutationSetLoading', false)
        throw error
      }
    },

    async actionProcessOrder ({ commit }, payload) {
      try {
        commit('mutationSetLoading', true)
        const orderRef = firebase
          .firestore()
          .collection('companies')
          .doc(payload.companyId)
          .collection('bots')
          .doc(constants.BOT_ID)
          .collection('subscribers')
          .doc(payload.subscriberId)
          .collection('orders')
          .doc(payload.orderId.toString())

        await orderRef.update({ status: payload.status })
        commit('mutationUpdateOrder', { orderId: payload.orderId, status: payload.status })
        if (payload.status === 'dispatched' || payload.status === 'cancelled') {
          commit('mutationDeleteOrder', payload.orderId)
        }
        commit('mutationSetLoading', false)
      } catch (error) {
        commit('mutationSetLoading', false)
        throw error
      }
    }

  },

  getters: {
    /**
     * @returns the orders loded to the state.
     */
    getLoadedOrders (state) {
      return state.orders
    },

    /**
     * @returns the orderDialog state.
     */
    getOrderDialog (state) {
      return state.orderDialog
    }

  }
}
